import type { RendererProps } from "../types";

import { MediaPreviewCarousel } from "./MediaPreviewCarousel";

import type { MediaPayload } from "@/routes/smart-table/utils/contentType";

export function MediaCollectionRenderer({ content }: RendererProps) {
  const items = (content.mediaPayload as MediaPayload[]) ?? [];

  if (items.length === 0) {
    return null;
  }

  return <MediaPreviewCarousel items={items} />;
}
